<template>
  <div class="row" style="margin-top: 49px;">
    <div class="col-md-6 offset-md-3">
      <div class="row">

        <!-- Left Form Section -->
        <div class="col-md-8 pr-md-5">
          <div class="form-group">
            <label>Start Date</label>
            <input type="date" class="form-control" v-model="startDate">
          </div>

          <div class="form-group">
            <label>Amount</label>
            <input type="number" class="form-control" placeholder="Enter Amount" v-model="amount">
          </div>

          <div class="form-group d-flex align-items-center">
            <div class="flex-grow-1">
              <label>Email to send Invoice</label>
              <div class="d-flex">
                <input type="email" class="form-control" placeholder="Enter Email" v-model="email">
                <button class="btn btn-outline-secondary px-3 py-1" @click="sendInvoice" type="button" :disabled="isLoading">
                  Send
                </button>

              </div>
            </div>
          </div>
          <br><br>
          <div class="text-center">
            <button type="button" class="btn submitBtn" @click="submitSubscription">Submit</button>&nbsp;
            <button type="button" class="btn cancelBtn" @click="cancel">Cancel</button>
          </div>
        </div>

        <!-- Divider -->
        <div class="col-md-1 d-none d-md-flex justify-content-center">
          <div style="width:1px; background:#ccc; height:100%;"></div>
        </div>

        <!-- Right Action Section -->
        <div class="col-md-3 text-center">
          <div class="mb-4">
            <select v-model="month" class="form-control d-inline-block w-100">
              <option value="">Select Month</option>
              <option v-for="(month, index) in monthsList" :key="index" :value="month.value">{{ month.label }}</option>
            </select>
          </div>

          <div class="mb-3">
            <button type="button" @click="viewInvoice" class="btn btn-outline-secondary btn-block py-2">
              View
            </button>
          </div>

          <div>
            <button type="button" @click="downloadInvoice" class="btn btn-outline-secondary btn-block py-2">
              Download
            </button>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment'

export default {
  props: ['restaurantId', 'jwtToken'],
  data() {
    return {
      monthsList: [
        { label: 'January', value: 'Jan' },
        { label: 'February', value: 'Feb' },
        { label: 'March', value: 'Mar' },
        { label: 'April', value: 'Apr' },
        { label: 'May', value: 'May' },
        { label: 'June', value: 'Jun' },
        { label: 'July', value: 'Jul' },
        { label: 'August', value: 'Aug' },
        { label: 'September', value: 'Sep' },
        { label: 'October', value: 'Oct' },
        { label: 'November', value: 'Nov' },
        { label: 'December', value: 'Dec' }
      ],
      month: '',
      startDate: '',
      amount: '',
      email: '',
      isUpdate: false,
      subscription: {},
      isLoading: false
    };
  },
  mounted() {
    this.getSubscription();
  },
  methods: {
    getSubscription() {
      const url = process.env.VUE_APP_API_URL + '/api/subscription?restaurantId=' + this.restaurantId;
      axios.get(url, {
        headers: {
          Authorization: `Bearer ${this.jwtToken}`,
        },
      })
      .then(response => {
        if (response.data) {
          this.subscription = response.data[0];
          this.startDate = moment(this.subscription.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
          this.amount = this.subscription.amount;
          this.isUpdate = true;
        }
      })
      .catch(error => {
        console.error('Error fetching subscription:', error);
      });
    },
    async submitSubscription() {
      if (!this.startDate || !this.amount) {
        this.$toastr.w("Please fill in start date and amount", "Warning")
        return;
      }

      const formattedDate = moment(this.startDate).format('DD/MM/YYYY');
      let payload;
      if (!this.isUpdate) {
        payload = {
          restaurantId: this.restaurantId,
          startDate: formattedDate,
          amount: this.amount,
        };
      } else {
        payload = {...this.subscription};
        payload.startDate = formattedDate;
        payload.amount = this.amount;
      }

      const url = process.env.VUE_APP_API_URL + (this.isUpdate ? '/api/subscription/update' : '/api/subscription/create');

      try {
        const response = await axios.post(url, payload, {
          headers: {
            Authorization: `Bearer ${this.jwtToken}`,
          },
        });
        this.$toastr.s('Subscription renewed successfully', "Success")
        this.subscription = response.data;
        this.isUpdate = true;
      } catch (error) {
        console.error('Error:', error);
        alert('Failed to ' + (this.isUpdate ? 'update' : 'create') + ' subscription');
      }
    },
    async sendInvoice() {
      this.isLoading = true
      if (!this.email || !this.month) {
        this.$toastr.w("Please fill in email and month", "Warning")
        this.isLoading = false
        return
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
        this.$toastr.w("Please enter a valid email address", "Warning")
        this.isLoading = false
        return
      }

      const url = process.env.VUE_APP_API_URL + '/api/subscription/sendInvoiceToEmail?restaurantId=' + this.restaurantId+'&month=' + this.month + '&to=' + this.email;
      try {
        const response = await axios.post(url, {}, {
          headers: {
            Authorization: `Bearer ${this.jwtToken}`,
          },
        });
        this.$toastr.s('Invoice sent successfully', "Success")
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        console.error('Error:', error);
        alert('Failed to send invoice');
      }
    },
    viewInvoice() {
      this.getInvoice(false);
    },
    downloadInvoice() {
      this.getInvoice(true);
    },
    async getInvoice(isDownload = false) {
      if (!this.month) {
        this.$toastr.w("Please select month", "Warning");
        return;
      }
      const url = process.env.VUE_APP_API_URL + '/api/subscription/getInvoice?restaurantId=' + this.restaurantId + '&month=' + this.month;
      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${this.jwtToken}`,
          },
          responseType: 'blob',
        });
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const blobUrl = window.URL.createObjectURL(blob);
        if (isDownload) {
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = 'invoice.pdf';
          link.click();
        } else {
          window.open(blobUrl, '_blank');
        }
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error('Error fetching invoice:', error);
        this.$toastr.e("Failed to fetch invoice", "Error");
      }
    },
    cancel() {
      window.location = '/admin/owner-list'
    },
  },
};
</script>
